import IconQuote from '~/svg/IconQuote.svg';

export type QuoteProps = {
  children: React.ReactNode;
};

export function Quote({ children }: QuoteProps) {
  return (
    <div className='text-subtitle-l-d grid w-full grid-cols-[3rem,1fr] items-center gap-6 rounded bg-gray-100 p-9 font-serif'>
      <IconQuote />
      {children}
    </div>
  );
}
